<template>
	<v-app v-if="tokenPainel!=''">

		<v-overlay :value="getShowLoading" absolute z-index="1000" opacity="0.2">
			<v-progress-circular
			indeterminate
			color="primary"
			></v-progress-circular>
		</v-overlay>	

		<!-- Sizes your content based upon application components -->
		<v-main  style="background-color:#F3F3F4" >
			<v-divider></v-divider>
			<v-subheader style="background-color:white">
				<h2 class="font-weight-light">{{getTitleScreen}}</h2>
				<v-spacer></v-spacer>
			
				<span class="mr-5" style="color:#D7D7D7">
				{{nameApp}}        
				</span>
			</v-subheader>
			<v-divider></v-divider>
			<!-- Provides the application the proper gutter -->
			
			<router-view></router-view>
			
		</v-main>

	</v-app>
	<router-view v-else></router-view>
</template>



<script>
	import {mapGetters} from 'vuex';
	// import itemMenu from './components/base/itemMenu.vue';

    export default {
		data(){
			return {				
			}
		},    	
		computed:{
			...mapGetters({
				isAuth: 'app/isAuth',
				tokenPainel: 'app/tokenPainel',
				getTitleScreen: 'app/getTitleScreen',
				getShowLoading:'app/getShowLoading',
				user:'app/user',		
				nameApp: 'app/nameApp'				
			})			
		}
    }
</script>